export enum SlaServiceTypeEnum {
  maintenance = 'MAINTENANCE',
  replacement = 'REPLACEMENT',
  implantation = 'IMPLANTATION',
}
